import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.js";
import "./app.css";

const root = document.getElementById("root");
if (root) {
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

// Financial data must survive storage pressure: ask for durable storage.
if (navigator.storage?.persist) {
  void navigator.storage.persist();
}

if ("serviceWorker" in navigator && !import.meta.env.DEV) {
  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/sw.js");
  });
}
